import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useClientSide from '../../hooks/use-client-side';
import { ChildrenPropType } from '../../types/component';
var propTypes = {
  children: ChildrenPropType.isRequired
};
export default function ClientSideContent(_ref) {
  var children = _ref.children;
  var _useClientSide = useClientSide(),
    _useClientSide2 = _slicedToArray(_useClientSide, 1),
    loaded = _useClientSide2[0];
  if (!loaded) {
    return null;
  }
  return children;
}
ClientSideContent.propTypes = propTypes;